module.exports = __webpack_public_path__ + "@/assets/img/app_store_ios.5c12bed2.svg";